export default __webpack_public_path__ + "static/tanulo_5-c2d7236a27840c71d8b16ca3913477f8.webp";